import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from './firebase';

remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

const DEFAULT_VALUES = { boolean: false, string: '', json: {}, number: 0 };

export const getRemoteConfigValue = (
  key: string,
  type: 'boolean' | 'string' | 'number' | 'json'
): any => {
  const value = getValue(remoteConfig, key);

  try {
    return type === 'boolean'
      ? value.asBoolean()
      : type === 'string'
        ? value.asString()
        : type === 'json'
          ? JSON.parse(value.asString()) || {}
          : value.asNumber();
  } catch (e) {
    return DEFAULT_VALUES[type];
  }
};

export const enableRemoteConfig = () => {
  fetchAndActivate(remoteConfig)
    .then(() => {})
    .catch((err) => {
      console.error(err);
    });
};
